export interface  TipoEdital {
    idTipoEdital:string;
    nome:string;
    ativo:boolean;
  }
  
  
  export enum EnumTipoEdital{
    IdSocial = "69EB3205-9127-4B27-AA76-062F9D1A56AF",
    IdPessoaJuridica = "B1A9E793-7CB4-4089-8985-218511DAB7B4"
  }


// WEBPACK FOOTER //
// ./src/app/models/tipo-edital.ts